import { OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT as OPTION_COLOR_THEMES_COLORFUL_LABELS } from './constants';

export const getRandomIndex = (hashValue: number): number => {
	const colorThemesLength = OPTION_COLOR_THEMES_COLORFUL_LABELS.length;

	const randomIndex = hashValue % colorThemesLength;

	return randomIndex;
};
